var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Top, CardType, ImageContainer, Body, FooterName } from './SocialCardStyles';
import { Link } from 'react-router-dom';
import { SmallFollowButton } from '../SmallFollowButton';
import moment from 'moment';
import DeleteCardOverlay from './DeleteCardOverlay';
import lazySizes from 'lazysizes';

import 'lazysizes/plugins/attrchange/ls.attrchange.js';

export default function withSocialCard(WrappedComponent) {
  return function (_Component) {
    _inherits(_class2, _Component);

    function _class2() {
      var _temp, _this, _ret;

      _classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
        deleting: false
      }, _this.toggleDelete = function () {
        _this.setState({ deleting: !_this.state.deleting });
      }, _this.cardTypeText = {
        deal: 'Offer',
        general: 'General',
        special: 'Special'
      }, _this.hasPurchases = function () {
        var _this$props = _this.props,
            post = _this$props.post,
            entities = _this$props.entities;


        return post.type === 'deal' && entities.get('vouchers').filter(function (v) {
          return v.get('deal_id') === post.deal().id;
        }).size > 0;
      }, _this.profileSlug = function (merchant, post) {
        if (merchant && merchant.slug) return merchant.slug;
        return post.vendor_id;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class2.prototype.render = function render() {
      var _this2 = this;

      var _props = this.props,
          entities = _props.entities,
          post = _props.post,
          admin = _props.admin;

      var image = post.postPicUrl('w_540,h_424,f_auto');

      var merchant = entities.get('merchant').find(function (m) {
        return m.get('vendor_id') === post.vendor_id;
      });

      if (!merchant || !image) return null;

      var profile = '/profile/' + this.profileSlug(merchant, post);

      return React.createElement(
        Wrapper,
        null,
        React.createElement(
          Top,
          null,
          React.createElement(
            CardType,
            null,
            this.cardTypeText[post.type]
          ),
          !admin && React.createElement(SmallFollowButton, _extends({}, this.props, {
            merchant: merchant,
            onClick: function onClick() {
              return _this2.props._merchant.follow(merchant);
            },
            style: { fontSize: '1.5rem' }
          }))
        ),
        this.state.deleting && React.createElement(DeleteCardOverlay, {
          deleteFn: function deleteFn() {
            return _this2.props._social.deletePost(_this2.props.post);
          },
          cancelFn: this.toggleDelete,
          cardType: post.type,
          hasPurchases: this.hasPurchases()
        }),
        React.createElement(
          Link,
          { to: '/profile/' + this.profileSlug(merchant, post) },
          React.createElement(
            ImageContainer,
            null,
            React.createElement('img', {
              src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
              'data-sizes': 'auto',
              'data-src': image,
              className: 'lazyload img-fluid',
              alt: ''
            })
          )
        ),
        React.createElement(
          Body,
          null,
          React.createElement(WrappedComponent, _extends({}, this.props, {
            toggleDelete: this.toggleDelete,
            merchant: merchant,
            image: image,
            profile: profile
          })),
          React.createElement('hr', { className: 'my-1' }),
          React.createElement(
            'footer',
            { className: 'd-flex align-items-center' },
            merchant.vendor.get('plan') === 'enhanced-full' && React.createElement(
              Link,
              { className: 'd-inline-block mr-2', to: profile },
              React.createElement('img', {
                className: 'lazyload',
                src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
                'data-src': merchant.profilePicUrl('f_auto,w_400,h_400,c_crop,g_face,r_max,b_rgb:ffffff/w_30,h_30/d_profile.png'),
                'data-sizes': 'auto',
                style: { height: '30px', width: '30px' },
                alt: 'profile'
              })
            ),
            React.createElement(
              FooterName,
              { to: profile },
              merchant.get('name')
            )
          )
        ),
        admin && React.createElement(
          'div',
          { className: 'px-half-gutter py-1 d-flex justify-content-end' },
          React.createElement(
            'button',
            {
              className: 'btn-unstyle text-gray-light',
              onClick: this.toggleDelete,
              style: { textDecoration: this.hasPurchases() ? 'line-through' : 'none' }
            },
            React.createElement('i', {
              className: 'fa text-danger icon-lv-cancel mr-2',
              'aria-hidden': 'true'
            }),
            'Delete this post'
          )
        )
      );
    };

    return _class2;
  }(Component);
}


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/social/SocialCard.js
// module id = 216
// module chunks = 4